export default "__VITE_ASSET__C5niz14v__"